<div class="setting">
  <nb-toggle status="primary" labelPosition="start" checked="true" (checkedChange)="toggleEditMode($event)">
    <nb-icon icon="settings-outline"></nb-icon>
  </nb-toggle>
  <nb-toggle status="danger" labelPosition="start" (checkedChange)="toggleRemoveMode($event)">
    <nb-icon icon="trash-2-outline"></nb-icon>
  </nb-toggle>
</div>
<div class="row w-100 small-block">
  <ng-container appDynamicComponentHost>
  </ng-container>
  <ngx-add-button *ngIf="editable" class="col-md-3 small-height" [size]="'small'" [haveOption]="false"
    (click)="addComponent()">
  </ngx-add-button>
</div>
<hr />
<!-- 右側選單選擇元件 -->
<nb-sidebar tag="selector" class="sidebar rightSidebar" end state="collapsed">
  <a class="toggleBtn" href="javascript: void(0)" (click)="sidebarToggle()">
    <nb-icon icon="chevron-right-outline" [ngClass]="{'rotate': !sideState}"></nb-icon>
  </a>
  <app-component-selector (choosed)="createComponent($event, true)">
    <nb-select class="right" placeholder="選擇資料年分" [(selected)]="selectedYear" (selectedChange)="selectedChange()">
      <nb-option value=2018>2018</nb-option>
      <nb-option value=2019>2019</nb-option>
      <nb-option value=2020>2020</nb-option>
    </nb-select>
  </app-component-selector>
</nb-sidebar>
